import { registerModal } from 'features/Modal/ModalRegistry'
import { VoiceCreateModal } from './VoiceCreateModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'CREATE_VOICE_MODAL'
registerModal(modalType, VoiceCreateModal)
export const showVoiceCreateModal = (modalProps: { talentID?: string }) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateModal/VoiceCreateModal.action.ts